import {
  FETCH_AVAILABLE_IN_BACKGROUND_REQUESTED,
  FETCH_AVAILABLE_FAILURE,
  FETCH_AVAILABLE_REQUESTED,
  FETCH_AVAILABLE_SUCCESS,
} from 'actiontypes/storylet';
import { processMessages } from 'actions/app';
import StoryletService from 'services/StoryletService';
import { IApiStoryletResponseData } from 'types/storylet/service';

const fetchAvailableRequest = (setisFetching: boolean) => ({
  type: setisFetching ? FETCH_AVAILABLE_REQUESTED : FETCH_AVAILABLE_IN_BACKGROUND_REQUESTED,
  phase: null,
});

export const fetchAvailableSuccess = (data: IApiStoryletResponseData) => ({
  type: FETCH_AVAILABLE_SUCCESS,
  payload: {
    actions: data.actions,
    endStorylet: data.endStorylet,
    phase: data.phase,
    storylets: data.storylets,
    storylet: data.storylet,
    messages: data.messages,
  },
});

const fetchAvailableFailure = (error: any) => ({
  type: FETCH_AVAILABLE_FAILURE,
  error: true,
  status: error && error.response && error.response.status,
});

const service = new StoryletService();

/** ----------------------------------------------------------------------------
 * FETCH AVAILABLE STORYLETS
 -----------------------------------------------------------------------------*/
export default function fetchAvailable({ setIsFetching = true } = {}) {
  return async (dispatch: Function) => {
    dispatch(fetchAvailableRequest(setIsFetching));

    try {
      const { data } = await service.fetchAvailable();
      dispatch(fetchAvailableSuccess(data));
      const { messages } = data;
      if (messages) {
        dispatch(processMessages(messages));
      }
      return data; // Return obj for chaining
    } catch (error) {
      dispatch(fetchAvailableFailure(error));
      return error;
    }
  };
}